/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Support_FaqInputs */

const en_mobile_support_faq = /** @type {(inputs: Mobile_Support_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support & FAQ`)
};

const es_mobile_support_faq = /** @type {(inputs: Mobile_Support_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte y preguntas frecuentes`)
};

/**
* | output |
* | --- |
* | "Support & FAQ" |
*
* @param {Mobile_Support_FaqInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_support_faq = /** @type {((inputs?: Mobile_Support_FaqInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Support_FaqInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_support_faq(inputs)
	return en_mobile_support_faq(inputs)
});